module.exports = __webpack_public_path__ + "static/media/scheduleIcon.183e6ef3.svg";